module.exports = __webpack_public_path__ + "img/jiadian.19d21d15.png";